import { Transaction } from "interfaces/data";
import { useNbpRates } from "./useNbpRates";
import { transactionCommitment } from "helpers/transactionCommitment";

export const useTransactionCommitment = (transaction: Transaction) => {
  const { rates: nbpRates } = useNbpRates();

  return transactionCommitment(transaction, nbpRates);
};
